import React from 'react';

import classNames from 'classnames';
import styles from './Tag.module.scss';
import { Icon, IconList, Loading, Text, VisuallyHidden } from 'components/core';

export type Props = {
  size?: 'sm' | 'md';
  children?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onRemove?: () => void;
  dataPendoKey?: string;
  component?: keyof HTMLElementTagNameMap | React.FunctionComponent<any>;
};

export const Tag = (props: Props) => {
  const {
    children,
    size = 'sm',
    isDisabled = false,
    isLoading = false,
    onRemove = () => '',
    dataPendoKey,
    component = 'div',
    ...rest
  } = props;
  const clazz = classNames(
    styles.Tag,
    styles[size],
    isDisabled && styles.disabled
  );

  return React.createElement(
    component,
    { className: clazz },
    <>
      <Text variant="neutral" size={size} {...rest}>
        {children}
      </Text>
      {!isDisabled && (
        <button
          className={styles.closeButton}
          onClick={onRemove}
          aria-label={isLoading ? 'Loading' : `Remove ${children}`}
          {...(dataPendoKey && { 'data-pendo-key': dataPendoKey })}
        >
          {isLoading ? (
            <Loading className={styles.loading} />
          ) : (
            <>
              {/* show this text when CSS is disabled, for a11y */}
              <VisuallyHidden>{`Remove ${children}`}</VisuallyHidden>
              <Icon size="sm" icon={IconList.light.faXmark} />
            </>
          )}
        </button>
      )}
    </>
  );
};
